import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';
import '../../../util/styles/index.js';
import { mergeProps } from '@react-aria/utils';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useSelectionListBox } from './useSelectionListBox.js';
import { useAdsStyles } from '../../../util/styles/hooks/useAdsStyles.js';

var useVirtualizedSelectionListBox = function useVirtualizedSelectionListBox(props) {
  var virtualizedHeight = props.virtualizedHeight;
  var _useSelectionListBox = useSelectionListBox(props),
    state = _useSelectionListBox.state,
    listBoxProps = _useSelectionListBox.listBoxProps,
    listBoxRef = _useSelectionListBox.listBoxRef,
    labelProps = _useSelectionListBox.labelProps;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;

  // Virtualized
  var parentRef = React.useRef(null);
  var virtualizer = useVirtualizer({
    count: _toConsumableArray(state.collection).length,
    getScrollElement: function getScrollElement() {
      return parentRef.current;
    },
    estimateSize: function estimateSize() {
      return 40;
    },
    // Size of each item
    overscan: 5,
    enabled: true
  });
  React.useEffect(function () {
    if (virtualizer) {
      virtualizer.measure();
    }
  }, [state.collection, virtualizer]);
  var listBoxStyle = mapAdsStyles({
    p: '0',
    m: '0',
    listStyle: 'none',
    overflow: 'visible',
    position: 'relative',
    height: "".concat(virtualizer.getTotalSize(), "px"),
    width: '100%'
  });
  var containerStyle = mapAdsStyles({
    overflow: 'scroll',
    height: virtualizedHeight ? "".concat(virtualizedHeight, "px") : '50dvh',
    position: 'relative',
    p: '4',
    // Make sure the container has padding, list box interactive state outline can be seen
    m: '-4'
  });
  return {
    state: state,
    listBoxProps: mergeProps(listBoxProps, listBoxStyle),
    containerProps: containerStyle,
    listBoxRef: listBoxRef,
    labelProps: labelProps,
    virtualizedProps: {
      parentRef: parentRef,
      virtualizer: virtualizer
    }
  };
};

export { useVirtualizedSelectionListBox };
//# sourceMappingURL=useVirtualizedSelectionListBox.js.map
